import { Grid } from "@analyticsMD/quil";

interface SectionGridProps {
  children: React.ReactNode;
}

const SectionGrid = ({
  children,
  ...rest
}: SectionGridProps): React.ReactElement => {
  return (
    <Grid container justifyContent="center" direction="row">
      <Grid item xs={0} />
      <Grid item xs={12}>
        {children}
      </Grid>
      <Grid item xs={0} />
    </Grid>
  );
};

export default SectionGrid;
